import { lazy as lazyLoad } from 'react';

import { route } from '../profile/constants';

import type { RouteDefinition } from '../../route';

const lazy = {
    EducationHistoryCreate: lazyLoad(async () => {
        const { EducationHistoryCreate } = await import('./EditEducationHistory');

        return { default: EducationHistoryCreate };
    }),
    EducationHistoryEdit: lazyLoad(async () => {
        const { EducationHistoryEdit } = await import('./EditEducationHistory');

        return { default: EducationHistoryEdit };
    }),
};

export const routes: readonly RouteDefinition[] = [
    {
        documentTitle: 'pages.user-education-history.title-add',
        page: lazy.EducationHistoryCreate,
        path: route.patterns.individualUser.educationHistory.create,
    },
    {
        documentTitle: 'pages.user-education-history.title-edit',
        page: lazy.EducationHistoryEdit,
        path: route.patterns.individualUser.educationHistory.edit,
    },
];
